import { Box, FormHelperText, TextField, Typography } from "@mui/material";
import { MprcJoinComponents } from "components";
import { AssessmentInstanceDto, AssessmentMode, AssessmentPlayerMode, AssessmentQuestionDto } from "generated/CoreApi_v1";
import React from "react";
import { useTranslation } from "react-i18next";
import { AssPlayerEssayRevision } from "views/assessment/player/Question/AssPlayerEssayRevision";
import { AssPlayerTotalAnswers } from "views/assessment/player/Question/AssPlayerTotalAnswers";

/////////////////////////////////////////////////////////////////////////////////

interface IProps {
    value?: string;
    viewData: AssessmentInstanceDto;
    question: AssessmentQuestionDto;
    onChange: (value: string) => void;
}

export const AssPlayerEssay: React.FC<IProps> = ({ value, question, viewData, onChange }) => {

    const { t } = useTranslation("assessment");

    ///
    const RenderAvailable = () => {
        return (
            <Box>
                <TextField
                    autoFocus
                    multiline
                    fullWidth
                    variant="outlined"
                    placeholder={question?.placeholderText ?? t("AssPlayer.Question.EssayPlaceholder")}
                    value={value}
                    minRows={(question?.maxLen ?? 255) > 255 ? 10 : 5}
                    maxRows={10}
                    disabled={viewData.playerMode == AssessmentPlayerMode.UserReview || viewData.playerMode == AssessmentPlayerMode.FinalResult}
                    slotProps={{
                        input: {
                            inputProps: { maxLength: question?.maxLen ?? 255 }
                        }
                    }}                    
                    onChange={(e) => onChange(e.target.value)}
                />
                <FormHelperText>
                    <Typography variant="caption">
                        <MprcJoinComponents
                            components={[
                                <Typography variant="caption">
                                    {t(question?.required ? "AssPlayer.Question.EssayRequiredTooltip" : "AssPlayer.Question.EssayOptionalTooltip")}
                                </Typography>,
                                <Typography variant="caption">
                                    {t("AssPlayer.Question.MaxLenTooltip", { total: question?.maxLen ?? 255, count: value?.length ?? 0 })}
                                </Typography>
                            ]}
                            separator={<span>&nbsp;&bull;&nbsp;</span>} />
                    </Typography>
                </FormHelperText>
            </Box>
        );
    };

    ///
    const RenderSurvRevision = () => {
        return (
            <>
                <Box>
                    <AssPlayerTotalAnswers
                        viewData={viewData}
                        question={question}
                    />
                </Box>
                <AssPlayerEssayRevision
                    instance={viewData}
                    question={question}
                />
            </>
        );
    };

    ////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////

    return (
        <>
            {
                viewData.mode == AssessmentMode.Survey && viewData.playerMode == AssessmentPlayerMode.FinalResult
                    ? RenderSurvRevision()
                    : RenderAvailable()
            }
        </>
    );
};
